import React, { useState } from 'react';
import {
  ExpandMore
} from "@mui/icons-material";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  Character,
  Attack,
} from "@dndModels";
import { ABILITY_SCORES, DAMAGE_TYPES } from "@dndModels/Constants";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import CheckBox from "@components/input/CheckBox";
import { DamageType } from "@dndModels/Types";

interface Props {
  character: Character;
  attack: Attack;
}

export default function CharacterAttackSidebar({
  character,
  attack,
}: Props) {
  const [ping, setPing] = useState(false);

  return (
    <div 
      style={{ 
        // backgroundColor: "white",
        // color: "black",
        height: "100%",
        overflowX: "hidden",
        padding: "4px",
        fontSize: "11px"
      }}>
      <Grid container spacing={0} direction="column">
        <Grid className="header centered">
          Unarmed Strike
        </Grid>
        <Grid style={{ fontWeight: "bold" }}>
          <Accordion>
            <AccordionSummary 
              style={{
                fontWeight: "bold",
                height: "30px"
              }}
              expandIcon={<ExpandMore />}>
              Customize
            </AccordionSummary>
            <AccordionDetails>
              <div style={{
                width: "100%"
              }}>
                <Grid container spacing={0} direction="row">
                  {/* <Grid
                    size={{
                      xs: 12
                    }}>
                    <StringBox
                      name="Unarmed Strikes Called"
                      value={ character.unarmed_strike_customizations.name }
                      onBlur={(value: string) => {
                        character.unarmed_strike_customizations.name = value;
                        character.subscription_holder.recalculate();
                        setPing(!ping);
                      }}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    <CheckBox 
                      name="Hidden"
                      value={character.unarmed_strike_customizations.hidden}
                      onChange={(changed: boolean) => {
                        character.unarmed_strike_customizations.hidden = changed;
                        character.subscription_holder.recalculate();
                        setPing(!ping);
                      }}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    <CheckBox 
                      name="Hide in PDF"
                      value={character.unarmed_strike_customizations.hide_in_pdf}
                      onChange={(changed: boolean) => {
                        character.unarmed_strike_customizations.hide_in_pdf = changed;
                        character.subscription_holder.recalculate();
                        setPing(!ping);
                      }}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    <SelectStringBox 
                      name="Bonus Action Unarmed Strikes"
                      value={character.unarmed_strike_customizations.bonus_action}
                      options={["Don't Override", "True", "False"]}
                      onChange={(changed: string) => {
                        character.unarmed_strike_customizations.bonus_action = changed;
                        character.subscription_holder.recalculate();
                        setPing(!ping);
                      }}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: character.unarmed_strike_customizations.count === undefined ? 12 : 3
                    }}>
                    <CheckBox 
                      name="Override Dice Count" 
                      value={ character.unarmed_strike_customizations.count !== undefined }
                      onChange={(changed: boolean) => {
                        if (changed) {
                          character.unarmed_strike_customizations.count = 1;
                        } else {
                          delete character.unarmed_strike_customizations.count;
                        }
                        character.subscription_holder.recalculate();
                        setPing(!ping);
                      }}
                    />
                  </Grid>
                  { character.unarmed_strike_customizations.count !== undefined &&
                    <Grid
                      size={{
                        xs: 9
                      }}>
                      <StringBox
                        name="Unarmed Strikes Dice Count"
                        value={ character.unarmed_strike_customizations.count }
                        type="number"
                        onBlur={(value: string) => {
                          character.unarmed_strike_customizations.count = +value;
                          character.subscription_holder.recalculate();
                          setPing(!ping);
                        }}
                      />
                    </Grid>
                  }
                  <Grid
                    size={{
                      xs: character.unarmed_strike_customizations.count === undefined ? 12 : 3
                    }}>
                    <CheckBox 
                      name="Override Dice Size" 
                      value={ character.unarmed_strike_customizations.count !== undefined }
                      onChange={(changed: boolean) => {
                        if (changed) {
                          character.unarmed_strike_customizations.count = 1;
                        } else {
                          delete character.unarmed_strike_customizations.count;
                        }
                        character.subscription_holder.recalculate();
                        setPing(!ping);
                      }}
                    />
                  </Grid>
                  { character.unarmed_strike_customizations.size !== undefined &&
                    <Grid
                      size={{
                        xs: 9
                      }}>
                      <StringBox
                        name="Unarmed Strikes Dice Size"
                        value={ character.unarmed_strike_customizations.size }
                        type="number"
                        onBlur={(value: string) => {
                          character.unarmed_strike_customizations.size = +value;
                          character.subscription_holder.recalculate();
                          setPing(!ping);
                        }}
                      />
                    </Grid>
                  }
                  <Grid
                    size={{
                      xs: character.unarmed_strike_customizations.scores === undefined ? 12 : 3
                    }}>
                    <CheckBox 
                      name="Override Ability Scores" 
                      value={ character.unarmed_strike_customizations.scores !== undefined }
                      onChange={(changed: boolean) => {
                        if (changed) {
                          character.unarmed_strike_customizations.scores = [];
                        } else {
                          delete character.unarmed_strike_customizations.scores;
                        }
                        character.subscription_holder.recalculate();
                        setPing(!ping);
                      }}
                    />
                  </Grid>
                  { character.unarmed_strike_customizations.scores !== undefined &&
                    <Grid
                      size={{
                        xs: 9
                      }}>
                      <SelectStringBox
                        name="Ability Scores"
                        values={ character.unarmed_strike_customizations.scores }
                        options={ABILITY_SCORES}
                        onChange={(changed: string[]) => {
                          character.unarmed_strike_customizations.scores = changed;
                          character.subscription_holder.recalculate();
                          setPing(!ping);
                        }}
                      />
                    </Grid>
                  }
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    <SelectStringBox 
                      name="Override Add Attack to Damage"
                      value={character.unarmed_strike_customizations.add_attack_to_dmg}
                      options={["Don't Override", "True", "False"]}
                      onChange={(changed: string) => {
                        character.unarmed_strike_customizations.add_attack_to_dmg = changed;
                        character.subscription_holder.recalculate();
                        setPing(!ping);
                      }}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: character.unarmed_strike_customizations.damage_types === undefined ? 12 : 3
                    }}>
                    <CheckBox 
                      name="Override Damage Types" 
                      value={ character.unarmed_strike_customizations.damage_types !== undefined }
                      onChange={(changed: boolean) => {
                        if (changed) {
                          character.unarmed_strike_customizations.damage_types = [];
                        } else {
                          delete character.unarmed_strike_customizations.damage_types;
                        }
                        character.subscription_holder.recalculate();
                        setPing(!ping);
                      }}
                    />
                  </Grid>
                  { character.unarmed_strike_customizations.damage_types !== undefined &&
                    <Grid
                      size={{
                        xs: 9
                      }}>
                      <SelectStringBox
                        name="Damate Types"
                        values={ character.unarmed_strike_customizations.damage_types }
                        options={DAMAGE_TYPES}
                        onChange={(changed: DamageType[]) => {
                          character.unarmed_strike_customizations.damage_types = changed;
                          character.subscription_holder.recalculate();
                          setPing(!ping);
                        }}
                      />
                    </Grid>
                  } */}
                </Grid>
              </div>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </div>
  );
}
